import React from 'react';
import Highcharts from 'highcharts';
import { options } from './options';
import { sentimentByRating } from './templates/sentimentByRating';

export class SegmentationChart extends React.Component {

  generateChart = (isFirstRender) => {
    const { chartId, data, tooltipFormatter, colors, disableAnimation } = this.props;
    const copyChartOptions = Object.assign({}, options);
    if (colors) {
      copyChartOptions.colors = colors;
    }
    Highcharts.setOptions(copyChartOptions);
    const copyChartType = Object.assign({}, sentimentByRating);

    // No spacing
    if (!copyChartType.chart) {
      copyChartType.chart = {};
    }
    copyChartType.chart.animation = !disableAnimation;
    copyChartType.chart.spacing = [0, 0, 10, 0];
    copyChartType.chart.spacingBottom = 10;
    copyChartType.chart.spacingTop = 0;
    copyChartType.chart.spacingLeft = 0;
    copyChartType.chart.spacingRight = 0;

    copyChartType.series = data;

    copyChartType.xAxis.minPadding = 0;
    copyChartType.xAxis.title = null;

    // Format y axis labels to go from 0 to anything
    copyChartType.yAxis.min = 0;
    copyChartType.yAxis.max = 100;
    copyChartType.yAxis.minPadding = 0;
    copyChartType.yAxis.softMin = 0;
    copyChartType.yAxis.softMax = 100;
    copyChartType.yAxis.tickInterval = 25;

    // No labels for y axis
    if (!copyChartType.yAxis.labels) {
      copyChartType.yAxis.labels = {};
    }
    copyChartType.yAxis.labels.enabled = false;

    // No labels for x axis
    if (!copyChartType.xAxis.labels) {
      copyChartType.xAxis.labels = {};
    }
    copyChartType.xAxis.labels.enabled = false;

    // Hide data labels if data is empty
    copyChartType.plotOptions.bar.dataLabels.enabled = (!!data && data.length > 0);
    copyChartType.plotOptions.series.animation = !disableAnimation;

    // Hide any labels on Zero data.
    copyChartType.plotOptions.bar.dataLabels.formatter = function () {
      if (this.y === 0) {
        return null;
      } else {
        return this.y;
      }
    };

    copyChartType.tooltip = {
      enabled: false,
      shared: true,
      useHTML: true
    };

    if (tooltipFormatter) {
      copyChartType.tooltip.formatter = function () {
        return tooltipFormatter(this);
      };
    }

    const chart = Highcharts.chart(chartId, copyChartType);
    if (isFirstRender) {
      chart.reflow();
    }
  };

  componentDidUpdate () {
    const { forceReflowBecauseOfBug } = this.props;
    this.generateChart(forceReflowBecauseOfBug);
  }

  componentDidMount () {
    this.generateChart(true);
  }

  render () {
    const { chartId, data, customChartContainerClass, customChartClass } = this.props;
    return (
      <div className={ `${!!customChartContainerClass && customChartContainerClass}` }>
        <div id={ chartId } className={ `${!!customChartClass && customChartClass}` } />
        { /* We need to use data prop somewhere in render or React won't watch it for changes. */ }
        <div key={ data ? data.length : 0 } />
      </div>
    );
  }
}
